import React from 'react';
import { Route } from 'react-router-dom';

import UnderConstruction from 'shared/ui/UnderConstruction';
import ConsultantNotifications from 'features/consultants/pages/ConsultantNotifications';
import ConsultantReport from 'features/consultants/pages/ConsultantReport';

export const consultantsRoutes = (
  <Route path='consultants'>
    <Route index element={<UnderConstruction />} />
    <Route path='statistics' element={<ConsultantReport />} />
    <Route path='notifications' element={<ConsultantNotifications />} />
    <Route path='schedule' element={<UnderConstruction />} />
    <Route path='settings' element={<UnderConstruction />} />
  </Route>
);

export const consultantsTitles = [
  { path: '/consultants/statistics', title: 'Отчет консультантов' },
  { path: '/consultants/notifications', title: 'Уведомления консультантов' },
  { path: '/consultants/schedule', title: 'График консультантов' },
  { path: '/consultants/settings', title: 'Настройки консультантов' },
  { path: '/consultants', title: 'Консультанты' },
];
